export default () => ({
  snackbar: {
    text: null,
    show: false,
    timeout: 5,
    type: "error",
    position: "top right",
  },
  drawer: {
    show: false,
    type: "beneficiary",
    content: {
      type: null,
      id: null,
    },
    history: [],
  },
  notifications: [],
});
